__turbopack_context__.v({
  "tabModuleDesktopWrapper": "tabModuleMain-module-scss-module__TIx0ta__tabModuleDesktopWrapper",
  "tabModuleMobileWrapper": "tabModuleMain-module-scss-module__TIx0ta__tabModuleMobileWrapper",
});
